import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const HouseIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 37 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 16.5634L17.0731 2.01775C17.2604 1.84811 17.4829 1.71355 17.7277 1.62173C17.9725 1.52992 18.235 1.48267 18.5 1.48267C18.765 1.48267 19.0275 1.52992 19.2723 1.62173C19.5171 1.71355 19.7396 1.84811 19.9269 2.01775L36 16.5634M5.03846 12.9087V29.3547C5.03846 30.3634 5.94308 31.1821 7.05769 31.1821H14.4615V23.2636C14.4615 22.2549 15.3662 21.4363 16.4808 21.4363H20.5192C21.6338 21.4363 22.5385 22.2549 22.5385 23.2636V31.1821H29.9423C31.0569 31.1821 31.9615 30.3634 31.9615 29.3547V12.9087M11.7692 31.1821H26.5769"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default HouseIcon;

HouseIcon.propTypes = customIconsPropTypes;
